import type React from 'react'
import styled, { css } from 'styled-components'

export interface InputLabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  children: React.ReactNode
  error?: boolean
  focused?: boolean
  highlighted?: boolean
  htmlFor: string
  required?: boolean
}

const StyledLabel = styled.label<{
  $error?: boolean
  $focused?: boolean
  $highlighted?: boolean
}>`
  display: inline-block;
  font-size: 0.875rem;
  line-height: 1 rem;
  color: ${({ $error, theme }) => ($error ? theme.colors.error[150] : theme.colors.field.label)};
  margin-bottom: 4px;
  transition: color 0.2s;

  ${({ $highlighted, theme }) =>
    $highlighted &&
    css`
      color: ${theme.colors.gray[100]};
      font-weight: 600;
    `}
`

const Asterisk = styled.span`
  color: ${({ theme }) => theme.colors.field.required};
  margin-left: 0.25em;
`

export function InputLabel({
  children,
  error,
  focused = false,
  highlighted = false,
  required,
  ...rest
}: InputLabelProps) {
  return (
    <StyledLabel $error={error} $focused={focused} $highlighted={highlighted} {...rest}>
      {children}
      {required && <Asterisk aria-hidden="true">*</Asterisk>}
    </StyledLabel>
  )
}
